import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { delay, filter, take, takeUntil } from "rxjs/operators";
import { UserProfileComponent } from "../../../../../../app/main/apps/user-profile/user-profile.component";
import { RouterModule } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { FuseNavigationService } from "@fuse/components/navigation/navigation.service";
import { FusePerfectScrollbarDirective } from "@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import Swal from "sweetalert2";

import { ApiService } from "../../../../../services/api.service";

@Component({
  selector: "navbar-vertical-style-1",
  templateUrl: "./style-1.component.html",
  styleUrls: ["./style-1.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarVerticalStyle1Component implements OnInit, OnDestroy {
  todayNumber: number = Date.now();
  todayDate: Date = new Date();
  todayString: string = new Date().toDateString();
  todayISOString: string = new Date().toISOString();

  fuseConfig: any;
  navigation: any;
  username;
  //  roletype;
  // Private
  private _fusePerfectScrollbar: FusePerfectScrollbarDirective;
  private _unsubscribeAll: Subject<any>;
  _fusePerfectScrolTimeOut;
  userData: any;
  defaultImage = "../../../../../../assets/images/admin/auto-transfer-icon.svg";
  ProfileImageKey;
  ProfileImageUrl;
  ProfileImageName;
  isFileSizeExceed: boolean = false;
  isSuperAdmin: boolean = false;
  time: any;
  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseNavigationService} _fuseNavigationService
   * @param {FuseSidebarService} _fuseSidebarService
   * @param {Router} _router
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseNavigationService: FuseNavigationService,
    private _fuseSidebarService: FuseSidebarService,
    private _router: Router,
    private apiService: ApiService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  // Directive
  @ViewChild(FusePerfectScrollbarDirective, { static: true })
  set directive(theDirective: FusePerfectScrollbarDirective) {
    if (!theDirective) {
      return;
    }

    this._fusePerfectScrollbar = theDirective;

    // Update the scrollbar on collapsable item toggle
    // this._fuseNavigationService.onItemCollapseToggled
    //     .pipe(
    //         delay(500),
    //         takeUntil(this._unsubscribeAll)
    //     )
    //     .subscribe(() => {
    //         this._fusePerfectScrollbar.update();
    //     });

    // Scroll to the active item position
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this._fusePerfectScrolTimeOut = setTimeout(() => {
          this._fusePerfectScrollbar.scrollToElement(
            "navbar .nav-link.active",
            -120
          );
        });
      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.username = localStorage.getItem("user");
    this.userData = JSON.parse(localStorage.getItem("userData"));

    // Check if 'firstLoginTime' is already set in localStorage
    if (!localStorage.getItem("firstLoginTime")) {
      // If not set, store the current time
      const firstLoginTime = new Date().toISOString();
      localStorage.setItem("firstLoginTime", JSON.stringify(firstLoginTime));
    }

    // Retrieve the stored first login time
    this.time = JSON.parse(localStorage.getItem("firstLoginTime"));

    if (this.userData && this.userData.ProfileImageUrl) {
      this.ProfileImageUrl = this.userData.ProfileImageUrl;
    }
    this.getUserAccessList(this.userData);

    // this.roletype = localStorage.getItem('userroletype');
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => {
        if (this._fuseSidebarService.getSidebar("navbar")) {
          this._fuseSidebarService.getSidebar("navbar").close();
        }
      });

    // Subscribe to the config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.fuseConfig = config;
      });

    // Get current navigation
    this._fuseNavigationService.onNavigationChanged
      .pipe(
        filter((value) => value !== null),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => {
        this.navigation = this._fuseNavigationService.getCurrentNavigation();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    clearTimeout(this._fusePerfectScrolTimeOut);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar opened status
   */
  toggleSidebarOpened(): void {
    this._fuseSidebarService.getSidebar("navbar").toggleOpen();
  }

  /**
   * Toggle sidebar folded status
   */
  toggleSidebarFolded(): void {
    this._fuseSidebarService.getSidebar("navbar").toggleFold();
  }

  getUserAccessList(userData) {
    if (
      userData &&
      userData.UserRoles &&
      userData.UserRoles[0] &&
      userData.UserRoles[0].UserType &&
      userData.UserRoles[0].UserType === "Super Admin"
    ) {
      this.isSuperAdmin = true;
    }
  }

  onSelectFile(e) {
    if (e.target.files) {
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event: any) => {
        this.ProfileImageUrl = event.target.result;
      };
    }
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.onSelectFile(event);
      const file = event.target.files[0];
      const size = file.size / 1024 / 1024;
      this.isFileSizeExceed = false;

      if (size > 5) {
        this.isFileSizeExceed = true;
        return;
      }
      this.ProfileImageUrl = file;
      this.ProfileImageName = file.name;

      this.uploadProfilePicture();
    }
  }

  uploadProfilePicture() {
    this.apiService
      .uploadProfilePicture(this.ProfileImageUrl)
      .subscribe((resultSet) => {
        if (!resultSet.error) {
          this.ProfileImageUrl = resultSet.data ? resultSet.data[0].url : "";
          this.ProfileImageKey = resultSet.data
            ? this.getProfImgKey(resultSet.data)
            : "";
          this.saveOrUpdateCall({
            ProfileImageName: this.ProfileImageName,
            ProfileImageUrl: this.ProfileImageUrl,
            ProfileImageKey: this.ProfileImageKey,
            UserId: this.userData && this.userData.Id ? this.userData.Id : "",
          });
        }
      });
  }

  getProfImgKey(data) {
    if (data && data[1] && data[1].param && data[1].param.Key) {
      return data[1].param.Key;
    }
    return "";
  }

  saveOrUpdateCall(editObj) {
    this.apiService
      .UpdateSuperAdminProfileImage(editObj)
      .subscribe((response) => {
        if (!response.error) {
          Swal.fire({
            title: response.message,
            icon: "success",
            showConfirmButton: true,
            timer: 2500,
            width: 400,
          });
        } else {
          Swal.fire({
            title: response.message,
            icon: "warning",
            showConfirmButton: true,
            timer: 2500,
            width: 400,
          });
        }
      });
  }
}
